export const SkillsListStyle = {
  card: {
    marginTop: '32px',
    position: 'relative',
  },
  cardDisabled: {
    backgroundColor: '#F3F4F6',
    pointerEvents: 'none',
  },
  cardHeader: {
    padding: '24px 24px',
  },
  cardContent: {
    padding: 0,
  },
  listViewMode: {
    padding: 0,
  },
} as const;
